import { getEsigningProviderMetadataByProviderId } from 'app/domains/esigning/utils';
import { useActiveEsigningProvider } from '../useActiveEsigningProvider';
export function useEsigningProviderMetadata() {
    const { provider } = useActiveEsigningProvider();
    const metadata = getEsigningProviderMetadataByProviderId(provider === null || provider === void 0 ? void 0 : provider.id);
    return metadata;
}
